const words = {
  spanish: {
    newR: "Nuevo Testimonio",
    text: "Su opinión es muy importante para nosotros!",
    cancel: "Cancelar",
    send: "Enviar",
    poor: "Pobre",
    medium: "Regular",
    good: "Bueno",
    veryGood: "Muy Bueno",
    excelent: "Excelente",
    nameRequired: "Por favor llene su nombre",
    scoreRequired: "Por favor seleccione un puntaje",
    reviewRequired: "Por favor déjenos su opinión",
  },
  english: {
    newR: "New Review",
    text: "Your opinion is very important to us",
    cancel: "Cancel",
    send: "Send",
    poor: "Poor",
    medium: "Normal",
    good: "Good",
    veryGood: "Very Good",
    excelent: "Excelent",
    nameRequired: "Please fill out your name",
    scoreRequired: "Please give us a score",
    reviewRequired: "Please leave us your opinion",
  },
};

export default words;
